module.exports = __webpack_public_path__ + "static/beauty-review-slider-section-c37dc2338264ab43eb80db90eefd487c.png";